import * as Yup from 'yup';

export default Yup.object()
  .shape({
    status: Yup.string().required('È richiesta la motivazione dell\'archiviazione'),
  });
